import React from 'react';
import { SIcon } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { LightGreyRoundedBox } from '../styled';
const EmptyCartContainer = styled(LightGreyRoundedBox) `
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: rgb(196,196,196);
`;
const EmptyCartPanel = () => (React.createElement(EmptyCartContainer, { className: 'pad-all-sm', "data-ref": 'empty-cart-panel' },
    React.createElement(SIcon, { name: 'shopping-cart', className: 'text-xxl' })));
export default EmptyCartPanel;
